import { useCallback, type ChangeEvent } from 'react'

import { useProductRefreshPreviewContext } from './productRefreshPreviewContext'

/**
 * Internal dev preview toggle: `checked` is the switch position; `onChange` updates the override.
 * The product refresh experience defaults to off; this override is only for internal dogfooding
 * when granular flags are visible. End users opt in via `activation_data.brand_refresh_beta.opted_in`.
 */
export function useProductRefreshPreviewToggle() {
  const { override, setOverride } = useProductRefreshPreviewContext()
  const checked = override === true
  const onChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setOverride(e.target.checked)
  }, [setOverride])
  return { checked, onChange }
}
